import { useMetricPerformanceContext } from "@src/contexts/ab-testing/metric-performance-context";
import { getEventParamType, parseEventParam } from "@src/helpers/text-helper";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { sliceFieldValue } from "@src/pages/ab-test-explore/helper/slice-field-value";
import { OperatorManager } from "@src/util/ab-testing/operator-manager";
import { Form } from "antd";
import dayjs from "dayjs";

type FilterInfoShowProps = {
    targetKey: string;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const FilterInfoShow: React.FC<FilterInfoShowProps> = ({ targetKey, open, setOpen }) => {
    const { form } = useMetricPerformanceContext();
    const filterWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_FILTER], form);
    const rules = filterWatch?.rules ?? [];
    if (rules.length === 0) return null;

    return (
        <div className="flex flex-wrap">
            <FilterTagShow
                rules={rules}
                showPrefix={true}
                onClick={() => {
                    setOpen(true);
                }}
            />
        </div>
    );
};

export const FilterTagShow: React.FC<{ rules?: any[]; onClick?: (rule: any) => void; showPrefix?: boolean }> = ({
    rules,
    onClick,
    showPrefix = false,
}) => {
    return (
        <>
            {showPrefix && <span className="mx-2">Filter:</span>}
            {rules?.map((rule: any) => {
                let _value: any[] = rule?.value;
                const valueType = getEventParamType(rule?.field);
                if (typeof rule?.value === "string" || typeof rule?.value === "number") {
                    _value = [rule?.value];
                } else if (valueType && ["string", "number"].includes(valueType)) {
                    _value = _value.map((v) => v);
                } else {
                    _value = _value.map((v) => (dayjs(v).isValid() ? dayjs(v).format("DD-MM-YYYY") : v));
                }

                const { result, remaining } = sliceFieldValue({ numSlice: 3, value: _value });

                return (
                    <div
                        onClick={() => {
                            onClick?.(rule);
                        }}
                        key={rule?.id + rule?.field}
                        className="my-1 py-[2px] px-2 border-[1px] border-solid border-gray-300 rounded-[4px] bg-gray-100/40 cursor-pointer hover:bg-gray-300/60 duration-300 mx-1 text-[12px]"
                    >
                        {rule?.field?.startsWith("ep_") ? `ep_${parseEventParam(rule?.field).param_key}` : rule?.field}{" "}
                        {OperatorManager.convertNameToSymbol(rule?.operator) ?? rule?.operator}{" "}
                        <span className="text-blue-500">
                            {result} {remaining > 0 ? `,   +${remaining}` : ""}
                        </span>
                    </div>
                );
            })}
        </>
    );
};
